import React, { Component } from "react";
import Answer from "./Components/Answer";
import Emoticon from "./Components/Emoticon";
import Stress from "./Components/Stress";
import Frame from "./Components/Frame";
import SpeechButton from "./Components/SpeechButton";
import { TIMEOUT_FOR_SEND_ANSWER } from "../constants/general";

class DialogScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null,
      frameAlertClass: "",
      tpicidViewClass: "",
      responseTime: 0, // used for testing purposes
    };

    this.handleAnswer = this.handleAnswer.bind(this);
    this.handleFrameAlert = this.handleFrameAlert.bind(this);
    this.handleSetResponseTime = this.handleSetResponseTime.bind(this);
  }

  handleSetResponseTime(time) {
    this.setState({ responseTime: time });
  }

  handleAnswer(aid, atp, aco) {
    console.log("Handling answer:", aid, atp, aco);
    console.log("Response time: " + this.state.responseTime + " seconds");

    if (this.state.selected) {
      return;
    }
    this.setState({ selected: aid });

    let that = this;
    // Add delay to simulate network request
    setTimeout(function () {
      that.props.handleAnswer(aid, atp, aco);
      console.log("Selected answer: " + aid);
    }, TIMEOUT_FOR_SEND_ANSWER);
  }

  handleFrameAlert(className) {
    this.setState({ frameAlertClass: className });
  }

  renderTester() {
    let tester = this.props.data.TESTER;
    if (!tester) {
      console.log("no data for rendering tester");
      return;
    }

    const stress = this.props.data.STRESS;

    let frame = this.props.data.FRAME;

    let bubble = "";
    if (tester.TTEXT.TLOOK === "MIND") {
      bubble = "mind";
    }
    if (tester.TTEXT.TLOOK === "SPEAK") {
      bubble = "speak";
    }

    if (tester.PICID && tester.PICID > 0) {
      if (this.state.tpicidViewClass === "") {
        this.setState({ tpicidViewClass: "tpicidview" });
      }
      let picidurl = `${process.env.REACT_APP_URL_API}/ademon/app/data/tpic/${tester.PICID}`;

      if (
        this.props.idcontext &&
        this.props.idcontext !== "" &&
        this.props.idcontext > 0
      ) {
        picidurl += "?idcontext=" + parseInt(this.props.idcontext);
      }
      return (
        <>
          <div className={"tester " + bubble}>
            <div className="tcontent">{tester.TTEXT.TCONTENT}</div>
            <div className="emoticon-box">
              <img className="img-fluid" src={picidurl} alt="emoticon" />
            </div>
          </div>

          <Stress
            data={stress}
            disabled={!!this.state.selected}
            handleAnswer={this.handleAnswer}
            handleSetResponseTime={this.handleSetResponseTime}
          />
          <Frame
            data={frame}
            disabled={!!this.state.selected}
            handleFrameAlert={this.handleFrameAlert}
          />
        </>
      );
    }

    return (
      <>
        <Emoticon id={tester.TEMOTIKONID} />

        <div className={"tester " + bubble}>
          <div className="tcontent">{tester.TTEXT.TCONTENT}</div>

          <SpeechButton
            media={tester.TSPKID}
            text={tester.TTEXT.TCONTENT}
            main={"true"}
          />
        </div>

        <Stress
          data={stress}
          disabled={!!this.state.selected}
          handleAnswer={this.handleAnswer}
          handleSetResponseTime={this.handleSetResponseTime}
        />
        <Frame
          data={frame}
          disabled={!!this.state.selected}
          handleFrameAlert={this.handleFrameAlert}
        />
      </>
    );
  }

  renderPersona() {
    let persona = this.props.data.PERSONA;

    if (!persona) {
      console.log("no data for rendering persona");
      return;
    }
    if (persona.PEMOTIKONID === "0") {
      return;
    }
    let answers = persona.PTEXT.ANSWER;

    return (
      <>
        <div className="answers">
          <div className="answers--inner">
            {answers.map((answer, i) => {
              let selected =
                this.state.selected && answer.AID === this.state.selected;
              return (
                <Answer
                  key={i}
                  data={answer}
                  disabled={!!this.state.selected}
                  selected={selected}
                  handleAnswer={this.handleAnswer}
                />
              );
            })}
          </div>
        </div>
      </>
    );
  }

  render() {
    let className = "App frame";
    if (this.state.frameAlertClass) {
      className += " " + this.state.frameAlertClass;
    }
    if (this.state.tpicidViewClass) {
      className += " " + this.state.tpicidViewClass;
    }
    return (
      <div className={className}>
        {this.renderTester()}
        {this.renderPersona()}
      </div>
    );
  }
}

export default DialogScreen;
